import Vue from 'vue'
import Vuex from 'vuex'
import demo from './modules/demo'
import data from './modules/data'
import persistedState from 'vuex-persistedstate'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        demo,
        data
    },
    plugins: [
        persistedState({
            storage: window.sessionStorage,
        })
    ],
})